<script setup lang="ts">
import type { Component } from "vue";

const props =
    defineProps<{
      itemNumber: string
      itemTitle: string
      itemContent: string
      itemIcon: Component
      enterDelay?: string
      isVisible?: boolean
    }>()
</script>

<template>
    <div class="rule-item flex flex-col items-center text-center w-full max-w-[280px] 2lg:w-[416px] 2lg:max-w-none 2lg:shrink-0 mx-auto" :class="{ 'is-visible': isVisible }" :style="{ '--enter-delay': enterDelay ?? '0s' }">
        <div class="rule-circle-wrap">
            <div class="rule-circle">
                <component :is="itemIcon" class="rule-icon" />
            </div>
        </div>
        <div class="rule-copy">
            <div class="text-3xl lg:text-[2.5rem] font-bold lg:pt-6 pb-1">{{ itemTitle }}</div>
            <div class="text-3xl lg:text-[2.5rem] font-light leading-snug pb-6 lg:pb-0" v-html="itemContent"></div>
        </div>
    </div>
</template>

<style scoped>
.rule-item {
    --ease-back: cubic-bezier(0.34, 1.56, 0.64, 1);
}

.rule-circle-wrap {
    position: relative;
}

.rule-circle {
    width: 190px;
    height: auto;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    transform: scale(0.92) translateY(30px);
    opacity: 0;
    transition:
        transform 0.6s var(--ease-back) var(--enter-delay),
        opacity 0.6s ease var(--enter-delay);
}

.rule-icon {
    height: auto;
    flex-shrink: 0;
    transition: transform 0.4s ease;
}

.rule-icon :deep(svg) {
    height: auto;
    display: block;
}

.rule-copy {
    opacity: 0;
    transform: translateY(16px);
    transition:
        transform 0.45s ease calc(var(--enter-delay) + 0.12s),
        opacity 0.45s ease calc(var(--enter-delay) + 0.12s);
}

.rule-item.is-visible .rule-circle {
    transform: scale(1) translateY(0);
    opacity: 1;
}

.rule-item.is-visible .rule-copy {
    opacity: 1;
    transform: translateY(0);
}

.rule-item:hover .rule-circle {
    transform: scale(1.12) translateY(-6px);
}

.rule-item:hover .rule-icon {
    transform: scale(1.06);
}

@media screen and (min-width: 1024px) {
    .rule-circle {
        width: 220px;
        height: 290px;
    }
}
</style>
